module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "toc"
  }, [_c('b', [_vm._v("Illustrations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/07_9781455619825_Chapter_02#fig1"
    }
  }, [_vm._v("1. Autopsy “Stare-of-Death” photo")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/07_9781455619825_Chapter_02#fig2"
    }
  }, [_vm._v("2. Kilduff at press conference")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/07_9781455619825_Chapter_02#fig3"
    }
  }, [_vm._v("3. Autopsy X-ray, side view")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/07_9781455619825_Chapter_02#fig4"
    }
  }, [_vm._v("4. Autopsy photo, back of head")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/07_9781455619825_Chapter_02#fig5"
    }
  }, [_vm._v("5. Low head entrance “explained”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/07_9781455619825_Chapter_02#fig6"
    }
  }, [_vm._v("6. FBI’s location of entrance wounds")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/07_9781455619825_Chapter_02#fig7"
    }
  }, [_vm._v("7. Zapruder frames 312-313")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/07_9781455619825_Chapter_02#fig8"
    }
  }, [_vm._v("8. Autopsy photo, back of head side view")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/11_9781455619825_Chapter_06#fig9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Backyard photos of Oswald")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/11_9781455619825_Chapter_06#fig10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Oswald Faces")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/14_9781455619825_Chapter_09#fig11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Bullet hole in jacket")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/14_9781455619825_Chapter_09#fig12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. Bullet hole in shirt")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/14_9781455619825_Chapter_09#fig13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Autopsy photo, back wound")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/14_9781455619825_Chapter_09#fig14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. Autopsy “face sheet”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/14_9781455619825_Chapter_09#fig15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. Drawings of wound locations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/14_9781455619825_Chapter_09#fig16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. CE 399and other comparison bullets")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/14_9781455619825_Chapter_09#fig17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. View from street to TSBD window")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/14_9781455619825_Chapter_09#fig18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. View from the “sniper’s nest”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/14_9781455619825_Chapter_09#fig19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. Overview of 7-shot-trajectory theory")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/14_9781455619825_Chapter_09#fig20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. Stretcher Bullet?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/14_9781455619825_Chapter_09#fig21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. Front view of shirt, slits")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/14_9781455619825_Chapter_09#fig22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. The base of CE 399")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/15_9781455619825_Chapter_10#fig23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23. Path of bullet/s through two men")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/15_9781455619825_Chapter_10#fig24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24. Zapruder frame 230")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/15_9781455619825_Chapter_10#fig25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25. Overview, TSBD lunchroom/staircase")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/15_9781455619825_Chapter_10#fig26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26. Overview of Tippit shooting area")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/15_9781455619825_Chapter_10#fig27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27. Triple Underpass from the west")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/15_9781455619825_Chapter_10#fig28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28. Drawings of head wound")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/15_9781455619825_Chapter_10#fig29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29. Mary Moorman photo")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/18_9781455619825_Epilog#fig30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30. Connally’s jacket")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ca48d040","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/04_9781455619825_Illustration.vue
// module id = 66
// module chunks = 0